export default __webpack_public_path__ + "media/transfer_window/Instruction_add_to_home_IOS-ff6a3c92.png";